import { render, staticRenderFns } from "./tblCompPropertiesTable.vue?vue&type=template&id=5b0eec76"
import script from "./tblCompPropertiesTable.vue?vue&type=script&lang=js"
export * from "./tblCompPropertiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports